<template lang="pug">
  //-
    Entity Form
    ---
    This Form is a recursive cmponent that is use only for populate a complex Entity object information.
    - TODO
    Decompose the parts of this object in several smaller components
  v-form
    //- pre {{ computedTabs }}
    .endButton.mb-1
      v-dialog(v-if="editMode && entityHasEntity && options.tabs", v-model="showDialog")
        template(v-slot:activator="{ on }")
          v-layout.pt-2.px-2(row, justify-end)
            v-btn.px-0(tile, text, color="geoBlue", v-on="on")
              span Add tab
              v-icon mdi-plus-circle
        v-card
          v-card-title.title.font-weight-bold Set Rules
          v-card-text
            app-create-field(
              v-model="newTab",
              :items="createTabItems",
              :types="listEntities",
              isTab
            )
          v-card-actions
            v-spacer
            v-btn(outlined, @click="addTab(newTab)") Save
    .endButton
      v-dialog(v-if="editMode && entityHasEntity && options.tabs && hasTabs", v-model="showDialogSection")
        template(v-slot:activator="{ on }")
          v-layout.pt-2.px-2(row, justify-end)
            v-btn.px-0(tile, text, color="geoPurple", v-on="on")
              span Add section
              v-icon mdi-plus-circle
        v-card
          v-card-title.title.font-weight-bold Set Rules
          v-card-text
            app-create-field(
              v-model="newSection",
              :items="createTabItems",
              :types="listEntities",
              isSection,
              :itemsSection="availableTabs",
            )
          v-card-actions
            v-spacer
            v-btn(outlined, @click="addTab(newSection)") Save
    //-
      Tabs Relations
      ---
      Use the tab option to show the relations as tabs. The options is a prop
      passed from the parent.
    v-tabs(
      v-model="tab",
      :dark="!fabStyle",
      :centered="fabStyle",
      v-if="options.tabs",
      :class="{ 'v-tabs--geodis': fabStyle }",
      show-arrows,
      :background-color="fabStyle ? undefined : 'primary'"
    )
      v-tab(
        v-for="(relation, index) in computedTabs",
        :key="relation.name",
        :href="`#${relation.name}`"
        :class="{ red: !fabStyle && entityHasErrors(relation) }",
        :ripple="!fabStyle"
      )
        span(v-if="!fabStyle") {{ $camelToString(getLabel(relation.name)) }}
        .v-tab__wrap(v-if="fabStyle")
          .v-tab__fab
            v-btn.d-inline-block.display-1.font-weight-light(
              fab,
              dark,
              :color="entityHasErrors(relation) ? 'red' : tab === relation.name ? 'geoBlue' : 'grey'"
            )
              span {{ index + (hasTabZero ? 0 : 1) }}
              //- v-icon(color="success") check
            .v-tab__name.grey--text {{ $camelToString(getLabel(relation.name)) }}
            .v-tab__remove.error(v-if="index > (hasTabZero ? 1 : 0) && editMode", @click.stop="removeTab(relation)")
              v-icon(small, color="white") mdi-close
          .v-tab__separator(v-if="index != 0")
            v-icon(large, color="grey") mdi-arrow-right
      //-
        Instance History
        ---
        Display the changes between two entries in the database, the old one and
        the new one. Only displayed when the entity already exists.
      v-tab(
        key="Instance-History",
        href="#Instance-History",
        :disabled="editMode",
        v-if="instance.entityState != 4"
      ) Instance History

      v-tab-item(:key="entity.tabLabel || entity.name", :value="entity.tabLabel || entity.name")
        slot(:name="entity.tabLabel || entity.name", :_instance="instance", :_entity="entity", :_errors="errors", :_edit-mode="editMode")
          app-entity-form(
            v-model="instance",
            :entity="entity",
            @update:entity="$emit('update:entity', $event)"
            :errors="errors",
            v-bind="{ editMode, disabled }",
            :options="{ hideExtras: true, }"
            :nested="nested + 1",
            :parent-entity="entity",
            :parent="instance",
            :relationName="entity.tabLabel || entity.name",
          )
      v-tab-item(v-if="hasTabZero", :key="tabZero.name", :value="tabZero.name")
        slot(name="tabZero")
          app-entity-form(
            :value="entity",
            @input="$emit('update:entity', $event)"
            :entity="tabZero",
            :errors="errors",
            :nested="nested + 1",
            disabled,
          )
      v-tab-item(
        v-for="relation in rootRelations",
        :key="relation.name",
        :value="relation.name"
      )
        slot(
          :name="relation.name",
          :_relation="relation",
          :_entity="$findEntity(relation.type)",
          :_errors="$formatErrors(errors, relation)",
          :_instance="instance[$lcfirst(relation.name)]",
          :_options="{ foreigns: true }",
          :_load="instance.id && { entity: instance, relation: relation.name }",
          :_parent="instance",
          :_disabled="disabled"
        )
          //- pre {{entity.name}}
          //- exception for files in order / shipment replace with document request for portals
          document-request(v-if="relation.type == 'File' && (entity.alias == 'Order' || entity.alias == 'Shipment')")
          //- if it isnt an order/shipment and relationship is anything other than file
          component(
            v-else
            v-model="instance[relation.name]",
            :is="relation.multiple ? 'app-old-entity-list' : 'app-entity-form'"
            :entity="$findEntity(relation.type)",
            :load="instance.id && { entity: instance, relation: relation.name }",
            :options="{ foreigns: true, deletes: editMode || options.deletes }",
            :errors="$formatErrors(errors, relation)",
            :ignore="{ relations:[] }",
            :finder="true",
            toggle,
            :parent="instance",
            :nested="nested + 1",
            :parent-entity="entity",
            :relationName="relation.name"
            @close="removeTab"
            v-bind="{ disabled }",
           )
      v-tab-item(
        key="Instance-History",
        value="Instance-History"
      )
        instance-history(:instance="instance")

    //-
      Entity Form
      ---
    div.entity-form(v-else)
      component(
        v-if="!!$replasable(entity.name, parentEntity)",
        :is="$replasable(entity.name, parentEntity)",
        @input="wut($event)"
      )
      v-container(v-else)
        v-form(v-if="instance || displayOnNull")
          v-row.mb-5(v-if="!noTitle", style="overflow: hidden")
            v-col.d-flex(cols="8")
              //- pre {{entity}}
              h2.display-1.font-weight-light.underline.underline--black {{ label || this.$camelToString(relationName) || this.$camelToString(entity.name) }}
              v-btn.ma-1(outlined, x-small, fab,
                v-if="toggle && !searchOnly"
                @click="createNew = !createNew"
              )
                v-icon(v-if="createNew")  mdi-magnify
                v-icon(v-if="!createNew")  mdi-plus
                // TODO: ON TOGGLE STATE PLEASE CLEAN ENTITY,
                // Should create a new entity, not just edit it
                // Fix autocomplete on create not letting search
            v-col.d-flex.justify-end(cols="4", v-if="options.deletes")
              v-icon(@click="$emit('close')")  mdi-close
          v-row(v-if="!noTitle")
            v-col.py-0
              h4.font-weight-light {{ loGet(entity, 'description') }}
          app-entity-autocomplete(
            v-if="(!entity.extra && toggle && !createNew && !entity.type == '_NO_TYPE_FIELD_') || searchOnly",
            :entity="entity",
            :init="instance",
            :whereCustom="whereCustom",
            @input="select"
          )
          template(v-if="editMode")
            app-entity-add-field(
              :fields="createFieldItems",
              @add-field="addField"
            )
          v-container(fluid)
            //- TODO: move outside, to the Portals views.
            //- :style="{'background-image': `url(${require('@/assets/grid-layout.png')})`,'background-size':'cover'}"
            v-row(v-if="!loading", justify-end, :class="{ 'form__grid': editMode }")
              v-col(:cols="getSizeField(field)", v-for="field in $fields(entity, 'primitive', ignoreTypes, only.fields, ignoreFields)")
                slot(:name="`${field.name}Field`")
                  app-field(
                    v-model="instance[$relationName(field)]",
                    @input="setExtraField(instance, field, $event)",
                    :key="field.label || field.name",
                    :field="field",
                    :errors="errors[field.name]",
                    :o="extraValue(field)",
                    @indexable="updateFieldProp(field, 'indexable', $event)",
                    @disabled="updateFieldProp(field, 'disabled', $event)",
                    @remove="deleteField(field.index)",
                    :edit-mode="editMode",
                    :entity="entity",
                    :disabled="disabled || ((toggle && !createNew) || searchOnly)"
                  )
              slot(name="FormFields")
              //-
                Chip Relations
                ---
                Use the foreign option to show the relations as chips buttons. The
                options are props passed from the parent.
              v-col(cols="12", v-if="options.foreigns")
                v-chip.mr-2(
                  v-for="(field, index) in chips",
                  @click="field.show = true",
                  v-if="!field.show",
                ) {{ field.name }}
              v-col(cols="12", v-if="options.foreigns")
                v-row(v-for="(field, index) in chips")
                  v-col.pt-0(cols="12", v-if="field.show")
                    app-entity-form(
                      @close="(field.show = false) ; (instance[$relationName(field)] = null)",
                      :parent="instance",
                      :parent-entity="entity",
                      :entity="$findEntity(field.type)",
                      :errors="errors[field.name]",
                      :label="entity.name + '.' + $findEntity(field.type).name",
                      :options="{ deletes: true, foreigns: true }",
                      :nested="nested + 1"
                      v-model="instance[$relationName(field)]",
                      :toggle="true",
                      :load="{entity: instance, relation: field.name}",
                      :finder="true",
                      :fromList="fromList",
                      :key="index"
                    )
            v-row(v-for="(section, index) in sections")
              v-col(cols="12")
                //- exception for files in order / shipment replace with document request for portals
                v-container(v-if="section.type == 'File' && (entity.alias == 'Order' || entity.alias == 'Shipment' || (entity.entity == 'Order' || entity.entity == 'Shipment'))")
                    v-col.d-flex.justify-end(cols="12", v-if="editMode || options.deletes")
                      v-icon(@click="removeTab(section)")  mdi-close
                    document-request
                //- if it isnt an order/shipment and relationship is anything other than file
                component(
                  v-else,
                  v-model="parent[section.name]",
                  :is="section.multiple ? 'app-old-entity-list' : 'app-entity-form'",
                  :entity="$findEntity(section.type)",
                  :load="instance.id && { entity: instance, relation: section.name }",
                  :options="{ foreigns: true, deletes: editMode || options.deletes }",
                  :errors="$formatErrors(errors, section)",
                  :ignore="{ relations:[] }",
                  :finder="true",
                  toggle,
                  :parent="instance",
                  :nested="nested + 1",
                  :parent-entity="entity",
                  :relationName="section.name",
                  @close="removeTab(section)",
                  v-bind="{ disabled }",
                )
            v-row(v-if="options.save")
              v-col.text-right
                v-btn.primary(@click="save") save
</template>

<script>

import axios from 'axios'
import { RenderMixin } from '@@/components/mixins'
import { AppEntityDelete } from '@@/components/entities'
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import InstanceHistory from '@@/components/InstanceHistory'
// To avoid issues in the next lines, we need to disable the eslint, we import
// all the input components from vuetify as workaround, due to an error using one
// of these within the "component" tag.
/* eslint-disable */
import {
  VRow,
  VCol,
  VIcon
} from 'vuetify/lib/components'

export default {
  components: {
    AppEntityAutocomplete,
    AppEntityDelete,
    VRow,
    VCol,
    VIcon,
    InstanceHistory
  },
  mixins: [RenderMixin],
  name: 'entity-form',
  props: {
    fabStyle: Boolean,
    finder: Boolean,
    noTitle: Boolean,
    fromList: Boolean,
    nested: {
      default: 0,
      type: Number
    },
    label: {
      type: String,
      default: null
    },
    entity: {
      type: Object,
      default: () => ({})
    },
    whereCustom: {
      type: Array,
      default: () => ([])
    },
    parentEntity: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({
        saves: false,
        deletes: false,
        foreigns: false
      })
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    load: {
      type: Object,
      default: () => ({})
    },
    parent: {
      type: Object,
      default: () => null
    },
    only: {
      type: Object,
      default: () => ({
        relations: []
      })
    },
    searchOnly: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    tabZero: {
      type: Object,
      default: () => ({}),
    },
    ignoreTypes: {
      type: Array,
      default: () => ([]),
    },
    ignoreFields: {
      type: Array,
      default: () => ([]),
    },
    customLabel: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showUser: {
      type: Boolean,
      default: false,
    },
    ignoreTabs: {
      type: Array,
      default: () => ([]),
    },
    relationName: {
      type: String,
      default: null,
    },
    displayOnNull: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tab: null,
      instance: {}, // TODO: check if it's needed to be null.
      relations: [],
      createNew: !this.toggle,
      dialog: {},
      newTab: {},
      newSection: {},
      watchOff: false,
      loading: true,
      showDialog: false,
      showDialogSection: false,
      lastValue: null,
      flag: false,
      mustUseDocumentRequest: false,
      chips: [],
    }
  },
  computed : {
    hasEntity(){
      return !_.isEmpty(this.entity);
    },
    entityHasEntity() {
      return !_.isEmpty(this.entity.entity);
    },
    hasTabZero() {
      return !_.isEmpty(this.tabZero);
    },
    rootRelations () {
      if (!this.hasEntity) return [];
      let fields = this.$fields(this.entity);
      if (fields)
        return fields
          .filter(f => !f.primitive && (this.showUser || f.type !== 'User') && (f.type !== 'ExtraData') && !f.section)
          .filter(f => !this.ignoreTabs.find(iT => f.name === iT));
      return [];
    },
    computedTabs() {
      let tabs = [];

      if((this.editMode && this.entityHasEntity && this.entity.name) || (!this.editMode && this.hasEntity && this.entity.name)) {
        tabs.push({ name: this.entity.tabLabel || this.entity.name })
      }

      if(this.hasTabZero) tabs = [{ name: this.tabZero.name }, ...tabs];
      return [...tabs, ...this.rootRelations];
    },
    createTabItems() {
      return this.entityHasEntity
        ? this.$findEntity(this.entity.entity)
            .fields
            .filter(x => !x.primitive)
            // .concat(this.$store.state.schema.all.filter(e => e.entity === this.entity.entity))
            // Commented, maybe it was used to get extra groups before.
            // Check if there are problems to uncomment, else delete it
          : [];
    },
    createFieldItems() {
      let entity = this.$findEntity(this.entity.entity);
      let extIdField = entity.fields.find(f => f.name == 'externalId');
      let fields = this.entityHasEntity
        ? entity
            .fields
            .filter(x => x.primitive)
            .filter(x => !ENV.ENTITY.FIELDS.IGNORE.some(i => x.name.endsWith(i)))
            // .concat(this.$store.state.schema.all.filter(e => e.entity === this.entity.entity))
            // Commented, maybe it was used to get extra groups before.
            // Check if there are problems to uncomment, else delete it
          : [];
      if (!!extIdField) fields.unshift(extIdField);
      return fields;
    },
    listEntities() {
      return this.$store.state.schema.all;
    },
    sections() {
      let parentFields = _.get(this.parentEntity, 'fields', []);
      return this.relationName ? parentFields.filter(f => f.section === this.relationName) : [];
    },
    availableTabs() {
      return _.tail(this.computedTabs);
    },
    hasTabs() {
      return !_.isEmpty(this.availableTabs);
    },
  },
  watch:{
    'entity.tabLabel'(val, oldVal) {
      if(!this.flag) {
        this.lastValue = oldVal;
        this.flag = true;
      }
      this.renameMainSections(val, oldVal);
    },
    'entity.name'(val, oldVal) {
      if(!this.entity.tabLabel) {
        if(!this.flag) {
          this.lastValue = oldVal;
          this.flag = true;
        }
        this.renameMainSections(val, oldVal);
      }
    },
  },
  methods: {
    renameMainSections: _.debounce(function(val, oldVal) {
      this.flag = false;
      const previousSection = _.isEmpty(this.lastValue) ? this.entity.name : this.lastValue;
      const newSection = _.isEmpty(val) ? this.entity.name : val;
      _.forEach(this.entity.fields, x => { if(x.section === previousSection) x.section = newSection });
    }, 500),
    wut (e) {
      this.instance = { ...this.instance, ...e };
    },
    /**
     * Check if the current entity has errors or if his relations has some errors
     * to do this we need to handle the errors that aren't in a relation to know
     * when the entity has errors, from here it's the same.
     */
    entityHasErrors (relation) {
      const isSame = relation.name === this.entity.name;
      const nonRelationErrors = Object.keys(this.errors)
        .filter(k => !this.rootRelations.some(r => k.match(r.name)));

      if (isSame && nonRelationErrors.length) return true;

      return Object.keys(this.$formatErrors(this.errors, relation)).length;
    },
    addTab (tabInfo) {
      console.log('[EntityForm][addTab]', this.$cleanString(tabInfo));
      if (!tabInfo.type) tabInfo.type = '_NO_TYPE_FIELD_';
      this.$emit('update:entity', {
        ...this.entity,
        fields: [...this.entity.fields, { ...tabInfo, primitive: false }]
      });
      this.showDialog = false;
      this.showDialogSection = false;
      this.newTab = {};
      this.newSection = {};
    },
    removeTab (relation) {
      if (!this.editMode) {
        this.$emit('close', relation);
        return;
      }
      const fields = [...this.entity.fields];
      const index = fields.findIndex(f => f.name == relation.name);

      if (!~index) return;
      fields.splice(index, 1);
      this.$emit('update:entity', {
        ...this.entity,
        fields
      });
    },
    addField (field) {
      let fieldToAdd = {...field};
      if (fieldToAdd.name == 'externalId' || fieldToAdd.alias == 'externalId')
        fieldToAdd.disabled = true;
      this.$emit('update:entity', {
        ...this.entity,
        fields: [...this.entity.fields, fieldToAdd ]
      });
    },
    deleteField(val) {
      let temp = [...this.entity.fields];
      temp.splice(val, 1);
      this.$emit('update:entity', {...this.entity, fields: temp});
    },
    getSizeField(val) {
      return val && val.size ? val.size : '4';
    },
    extraValue (field) {
      var v =
        this.entity.extra &&
        this.parent &&
        this.parent.extraData &&
        this.parent.extraData.find(e => Number(field.extraFieldId) === Number(e.extraFieldId))
      return v ? v.value : undefined;
    },
    setExtraField (instance, field, value) {
      if (this.entity.extra && this.parent) {
        this.parent.extraData = this.parent.extraData || [];
        var data = this.parent.extraData
          .find(d => d.extraFieldId === field.extraFieldId);
        if (!data) {
          this.parent.extraData.push({
          // ********************************************
          // _Type PROPERTY MUST BE SET BEFORE THE value PROPERTY DO NOT MOVE DOWN
            _Type: field.type,
          // ********************************************
            extraFieldId: field.extraFieldId,
            value,
            _Entity: 'ExtraData',
            entityState: ENV.ENTITY.STATE.ADDED
          });
        }
        else {
          data.entityState = ENV.ENTITY.STATE.MODIFIED;
          data.value = value;
        }
      }
    },
    async save () {
      this.instance = (await axios.post('entity/graph', this.instance)).data;
    },
    async select (instance) {
      this.instance = instance;
      this.rerender();
    },
    initInstance () {
      return {
        _Entity: this.entity.name,
        ...this.value,
        entityState: this.instance && this.instance.id
          ? ENV.ENTITY.STATE.UNCHANGED
          : ENV.ENTITY.STATE.ADDED
      };
    },
    updateFieldProp (field, prop, val) {
      const fields = [...this.entity.fields]; // Remove observable
      fields[field.index][prop] = val;
      this.entity.fields = fields; // Trigger reactivity.
    },
    hasFilesRelationShip() {
     if (this.entity && this.entity.fields){
       return this.entity.fields.some(f => f.type == 'File');
     }
     return false;
    },
    getLabel(val) {
      if (_.isEmpty(val)) return '';
      return _.get(this.customLabel, val, val);
    },
    loGet(obj, path, baseValue = null) {
      return _.get(obj, path, baseValue);
    },
  },
  async created () {
    let fields = this.$fields(
      this.entity,
      'foreign',
      this.parent && [this.parent._Entity],
      this.only.relations
    );
    if (this.options.foreigns && !this.entity.type == '_NO_TYPE_FIELD_')
      this.relations = fields.map(i => ({ ...i, show: false }));
    if (this.load.entity && this.load.entity.uid && !this.entity.extra && _.isEmpty(this.value) && this.entity.nonRelationTab) {
      var instance = (
        await this.$fetchEntity(this.load.entity, [this.load.relation], axios)
      )[this.$lcfirst(this.load.relation)];
    }
    this.chips = this.$fields(this.entity).filter(_f => !_f.primitive && !_f.multiple);
    this.instance = instance || this.initInstance();
    // TODO: This is a workaround for an issue when the instance in the parent is not
    // initialized first, it will override the previous components values when an input from the parent
    // is sent. Working without problems after it. It's a slot related problem.
    if (!this.fromList) {
      this.$emit('input', this.instance);
    }
    this.rerender();
    /**
     * TODO: refactor recursive code (forms, lists, fields)
     * So... I know when it happens, but I cannot figure out why it's happening,
     * the next lines are the workaround, making a watcher dynamically avoids
     * to execute it from the start, so we declare the watcher after the
     * assignation of the instance.
     */
    this.$watch('instance', {
      deep: true,
      handler (instance) {
        if (instance && instance.id)
          instance.entityState = ENV.ENTITY.STATE.MODIFIED;
        instance && !this.watchOff && this.$emit('input', instance);
        this.watchOff = false;
      }
    })
    // This AI is more than you simple mortal... Check a better way to perform this
    // block, also see the performance using watchers and emits recursively.
    this.$watch('value', value => {
      this.watchOff = true;
      this.instance = { ...this.instance, ...value };
    })
  },
  async mounted () {
    this.loading = false;
    // check that this entity has alias and must be either pointing to order or shipment
    if (this.entity && this.entity.alias && (this.entity.alias == 'Order' || this.entity.alias == 'Shipment'))
      this.mustUseDocumentRequest = this.hasFilesRelationShip(); // set flag that especifies using document request for files in this entity
  }
}
</script>
